import { useIntl, createIntl } from "@platform/cj-platform-navigation"

export const intl = () => {
    try {
        const intl = useIntl()
        return intl
    } catch {
        return createIntl({ locale: "en" })
    }
}